import state from './state'

export default {
  state,
  namespaced: true,
}
